import { createSlice, current } from '@reduxjs/toolkit';
import { getBacklinks, addBacklink, deleteBacklinks } from '../thunks/backlinks';
import { mergeArrayByKey } from '../../utils/helpers/array';

export const backlinksSlice = createSlice({
  name: 'backlinks',
  initialState: {
    backlinks: [],
    isFetching: false,
    currentPage: 1,
    limit: 10,
    totalDocs: 0,

    isUpdating: {},

    domainBacklinks: [],
  },

  reducers: {
    setCurrentPage: (state, action) => {
      if (action.payload === 1) {
        state.orders = [];
      }

      state.currentPage = action.payload;
    }
  },

  extraReducers: {
    [getBacklinks.pending]: (state, action) => {
      state.isFetching = true;
    },
    [getBacklinks.fulfilled]: (state, action) => {
      const { backlinks, totalDocs, domainBacklinks } = action.payload;

      state.isFetching = false;
      state.totalDocs = totalDocs;

      const currentState = current(state);
			state.backlinks = currentState.currentPage === 1 ? [...backlinks] : mergeArrayByKey([...currentState.backlinks, ...backlinks], '_id');
    
      state.domainBacklinks = domainBacklinks;
    },
    [getBacklinks.rejected]: (state, action) => {
      state.isFetching = false;
    },

    [addBacklink.pending]: (state, action) => {
      state.isUpdating[action.meta.arg.id] = true;
    },
    [addBacklink.fulfilled]: (state, action) => {
      const currentState = current(state);
      state.backlinks.push(action.payload);
      state.totalDocs = currentState.totalDocs + 1;
      state.currentPage = Math.trunc(currentState.totalDocs / currentState.limit) + 1;
      state.isUpdating[action.meta.arg.id] = false;
    },
    [addBacklink.rejected]: (state, action) => {
      state.isUpdating[action.meta.arg.id] = false;
    },

    [deleteBacklinks.pending]: (state, action) => {
      action.meta.arg.ids.forEach(id => {
        state.isUpdating[id] = true;
      });
    },
    [deleteBacklinks.fulfilled]: (state, action) => {
      const currentState = current(state);
      state.backlinks = currentState.backlinks.filter(backlink => !action.payload.includes(backlink._id));
      state.totalDocs = currentState.totalDocs - 1;
      state.currentPage = Math.trunc(currentState.totalDocs / currentState.limit) + 1;
      action.payload.forEach(id => {
        state.isUpdating[id] = false;
      });
    },
    [deleteBacklinks.rejected]: (state, action) => {
      action.meta.arg.ids.forEach(id => {
        state.isUpdating[id] = false;
      });
    }
  }
});

export const { setCurrentPage } = backlinksSlice.actions;

export default backlinksSlice.reducer;
